import React from "react"
import { Segment, Grid, Button } from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { changeToggleOption } from "../../../../actions/analytics-v2"
import PropTypes from "prop-types"
import { WasAggregateSelected, WasCurrencyUnitsSelected, WasPhysicalStockSelected } from "../../../../utils/constants"
import "./ToggleSection.css"

const ToggleSection =
({ analyticsToggleOptions,
    changeToggleOption,
    disableAnalyticsContentInteraction
})=>{

    const { t } = useTranslation()

    const toggleKeyByButtonLabel = {
        [t("analytics.aggregated")]: WasAggregateSelected,
        [t("analytics.singleItem")]: WasAggregateSelected,
        [t("analytics.currencyButton")]: WasCurrencyUnitsSelected,
        [t("analytics.countButton")]: WasCurrencyUnitsSelected,
        [t("analytics.physicalStock")]: WasPhysicalStockSelected,
        [t("analytics.totalStock")]: WasPhysicalStockSelected,
    }

    const toggleOptionsHandler = (buttonName)=>{
        const toggleKey = toggleKeyByButtonLabel[buttonName]
        changeToggleOption({...analyticsToggleOptions, [toggleKey]: !analyticsToggleOptions[toggleKey]})
    }

    // pink zone / stock split only exists on the aggregated, currency-based chart
    const isStockToggleApplicable = analyticsToggleOptions[WasAggregateSelected] && analyticsToggleOptions[WasCurrencyUnitsSelected]
    const disableStockToggle = disableAnalyticsContentInteraction || !isStockToggleApplicable

    return(
        <Segment className="side-button">
            <label>{t("analytics.options")}</label>    
            <Grid.Row>
                <Button.Group fluid>
                    <Button 
                        toggle 
                        active={analyticsToggleOptions[WasAggregateSelected]}
                        onClick={(e, data)=>toggleOptionsHandler(data.children)}
                        disabled={disableAnalyticsContentInteraction}>
                        {t("analytics.aggregated")}
                    </Button>
                    <Button 
                        toggle 
                        active={!analyticsToggleOptions[WasAggregateSelected]}
                        onClick={(e, data)=>toggleOptionsHandler(data.children)}
                        disabled={disableAnalyticsContentInteraction}
                        >
                        {t("analytics.singleItem")}
                        </Button>
                    </Button.Group>
            </Grid.Row>

            <label className="space-title">{t("simulation.chartType")}</label>
            <Grid.Row>
                <Button.Group fluid>
                    <Button 
                        toggle 
                        active={analyticsToggleOptions[WasCurrencyUnitsSelected]} 
                        onClick={(e, data)=>toggleOptionsHandler(data.children)}
                        disabled={disableAnalyticsContentInteraction}>
                            {t("analytics.currencyButton")}
                    </Button>
                    <Button
                        toggle
                        active={!analyticsToggleOptions[WasCurrencyUnitsSelected]}
                        onClick={(e, data)=>toggleOptionsHandler(data.children)}
                        disabled={disableAnalyticsContentInteraction}>
                            {t("analytics.countButton")}
                    </Button>
                </Button.Group>
            </Grid.Row>

            <label className={`space-title ${disableStockToggle ? "disabled" : ""}`}>{t("analytics.stock")}</label>
            <Grid.Row>
                <Button.Group fluid>
                    <Button
                        toggle
                        active={!isStockToggleApplicable || analyticsToggleOptions[WasPhysicalStockSelected]}
                        onClick={(e, data)=>toggleOptionsHandler(data.children)}
                        disabled={disableStockToggle}>
                            {t("analytics.physicalStock")}
                    </Button>
                    <Button
                        toggle
                        active={isStockToggleApplicable && !analyticsToggleOptions[WasPhysicalStockSelected]}
                        onClick={(e, data)=>toggleOptionsHandler(data.children)}
                        disabled={disableStockToggle}>
                            {t("analytics.totalStock")}
                    </Button>
                </Button.Group>
            </Grid.Row>
        </Segment>
    )
}

ToggleSection.propTypes = {
    analyticsToggleOptions: PropTypes.object,
    changeToggleOption: PropTypes.func,
    disableAnalyticsContentInteraction: PropTypes.bool
}

const mapStateToProps = (state)=>({
    analyticsToggleOptions: state.analytics.analyticsToggleOptions,
    disableAnalyticsContentInteraction: state.analytics.disableAnalyticsContentInteraction
})

export default connect(mapStateToProps, { changeToggleOption })(ToggleSection)